// Ticket display-name lookup. Tickets are generic single-use credits
// stored as `(user_id, ticket_id slug, count)` rows in `user_tickets`.
// The server only ever sees the slug — display strings live here so the
// game-over reward screen, the admin panel, and any future inventory UI
// can render the same human-readable name without each surface keeping
// its own copy.
//
// Adding a new ticket kind: append an entry below. Unknown slugs fall
// back to the slug itself, so a brand-new ticket id surfaces a readable
// (if ugly) string until someone wires up its display name.

export const TICKET_NAMES: Record<string, string> = {
  'free-basic-pack':   'FREE Basic Pack',
  'free-premium-pack': 'FREE Premium Pack',
  'free-custom-pack':  'FREE Custom Pack',
  'auction-listing':   'Auction Ticket',
};

export function ticketDisplayName(id: string): string {
  return TICKET_NAMES[id] ?? id;
}
